import { useEffect } from 'react';

type PasteTarget = Pick<Window, 'addEventListener' | 'removeEventListener'>;

const usePasteFromBuffer = (
  callback?: ((event: ClipboardEvent | Event) => unknown) | null,
  condition = false,
  element: PasteTarget = window,
) => {
  useEffect(() => {
    if (condition && callback) {
      element.addEventListener('paste', callback as EventListener);
    }

    return () => {
      if (condition && callback) {
        element.removeEventListener('paste', callback as EventListener);
      }
    };
  }, [callback, condition, element]);
};

export default usePasteFromBuffer;
